import useZoneDetector from './useZonesDetector'
import { Alert, Loading } from '../../components/common'
import { ZoneTypeEnum } from '../../shared/types'
import CaseZone from '../../features/Zone/types/CaseZone/CaseZone'
import BriefZone from '../../features/Zone/types/BriefZone/BriefZone'
import CaseRouter from '../../routes/CaseRouter'
import BriefRouter from '../../routes/BriefRouter'
import Zone from '../../features/Zone/Zone'
import AppRouter from '../../routes/AppRouter'
import { DebugExitZone } from '../../components/debug'
import ZoneAdverts from '../../pages/ZoneAdverts/ZoneAdverts'
import Intro from '../../pages/Intro/Intro'

const ZoneDetector = () => {
  const { activeZone, loading, loadingMsg, error } = useZoneDetector()

  const renderZoneContent = () => {
    switch (activeZone?.type) {
      case ZoneTypeEnum.Case:
        return (
          <CaseZone>
            <CaseRouter />
          </CaseZone>
        )
      case ZoneTypeEnum.Brief:
        return (
          <BriefZone>
            <BriefRouter />
          </BriefZone>
        )
      default:
        return null
    }
  }

  let content
  // if (zoneIntro) content = <Intro />
  if (!activeZone) content = <ZoneAdverts />
  else if (renderZoneContent) content = <Zone>{renderZoneContent()}</Zone>
  else content = null
  {
    /* {renderZoneContent ? <Zone>{renderZoneContent()}</Zone> : <AppRouter />} */
  }

  return (
    <Loading
      loading={loading && !error}
      fullscreen
      message={`${loadingMsg}...`}
    >
      {error && <Alert title="Unable to get location">{error}</Alert>}
      {content}

      {/* Use in case of app breaking */}
      {/* <DebugExitZone mode="debug" /> */}
    </Loading>
  )
}

export default ZoneDetector
